"use client"

import {useMemo} from "react"
import {useTranslations} from "next-intl"
import {getInboxSourceLabels, getInboxAttentionHint} from "@/lib/inbox/types"

export function useInboxPresentation() {
  const t = useTranslations("InboxAttention")
  return useMemo(() => ({INBOX_SOURCE_LABELS: getInboxSourceLabels(t), ATTENTION_HINT: getInboxAttentionHint(t)}), [t])
}
